const tbSiteHazards = {
  table: 'tb_site_hazards',
  idKey: 'id',

  attrs: [
    'creationDate',
    'lastModifiedDate',
    'deleted'
  ],

  relationships: [    
    {
      type: 'companies',
      key: 'company',
    },
    {
      type: 'toolboxes',
      key: 'toolbox',
    },
    {
      type: 'site-hazards',
      key: 'siteHazard',
    }
  ],
}

export default tbSiteHazards